import React, { Fragment, useEffect, useMemo, useState } from 'react';
import styles from './styles.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const findInObject = (haystack, needle) =>
  haystack.find((cl) => cl.deeplink === needle) ??
  haystack.find((cl) => cl.moi === needle) ??
  haystack.find((cl) => cl.id === needle);

export const CarImage = ({ carIn, carOut, small = false, last = false }) => {
  const [show, setShow] = useState(false);
  const [currentModel, lastModel] = useMemo(
    () => [
      findInObject(window.hwsconfig.carlines, carIn),
      findInObject(window.hwsconfig.carlines, carOut),
    ],
    [window.hwsconfig.carlines, carIn, carOut]
  );

  const { inStyle, outStyle, inStyleSmall, inStyleLast } = useMemo(() => {
    const result = {
      inStyle: undefined,
      outStyle: undefined,
      inStyleSmall: currentModel ? { backgroundImage: undefined } : undefined,
      inStyleLast: currentModel ? { backgroundImage: undefined } : undefined,
    };

    if (currentModel && currentModel.leadformImage) {
      result.inStyle = {
        backgroundImage:
          window.devicePixelRatio === 1
            ? `url("${currentModel.leadformImage.thumbnails['600x600']}")`
            : `url("${currentModel.leadformImage.src}")`,
      };
      result.inStyleSmall = {
        backgroundImage: `url("${currentModel.leadformImage.thumbnails['320x240']}")`,
      };
      result.inStyleLast = result.inStyle;
    }

    if (lastModel && lastModel.leadformImage) {
      result.outStyle = {
        backgroundImage:
          window.devicePixelRatio === 1
            ? `url("${lastModel.leadformImage.thumbnails['600x600']}")`
            : `url("${lastModel.leadformImage.src}")`,
      };
    }

    return result;
  }, [currentModel, lastModel]);

  useEffect(() => {
    setShow(false);
    window.setTimeout(() => setShow(true), 500);
  }, [carIn]);

  if (!currentModel && !lastModel) {
    return null;
  }

  if (small) {
    return !inStyleSmall && !outStyle ? null : (
      <div className={styles.containerSmall} aria-hidden={'true'}>
        {show ? (
          <Fragment>
            {inStyleSmall && <div className={cx(styles.carImageSmall)} style={inStyleSmall} />}
            {currentModel && (
              <h4
                className={cx(
                  styles.carName,
                  !currentModel.leadformImage ? styles.carNameNoImage : undefined
                )}
              >
                {currentModel.label}
              </h4>
            )}
          </Fragment>
        ) : (
          <Fragment>
            {carOut && outStyle && (
              <div className={cx(styles.carImageSmall, styles.moveOutSmall)} style={outStyle} />
            )}
            {carIn && inStyleSmall && (
              <div className={cx(styles.carImageSmall, styles.moveInSmall)} style={inStyleSmall} />
            )}
          </Fragment>
        )}
      </div>
    );
  }

  if (last) {
    return !inStyleLast && !outStyle ? null : (
      <div className={styles.containerLast}>
        {show ? (
          <Fragment>
            <div className={cx(styles.carImageLast)} style={inStyleLast} />
            {currentModel && <div className={styles.carNameLast}>{currentModel.label}</div>}
          </Fragment>
        ) : (
          <Fragment>
            {carIn && (
              <div className={cx(styles.carImageLast, styles.moveInLast)} style={inStyleLast} />
            )}
            {carOut && (
              <div className={cx(styles.carImageLast, styles.moveOutLast)} style={outStyle} />
            )}
          </Fragment>
        )}
      </div>
    );
  }

  return !inStyle && !outStyle ? null : (
    <div className={cx(styles.containerBig)}>
      {show ? (
        <div className={cx(styles.carImageBig)} style={inStyle} />
      ) : (
        <Fragment>
          {carIn && <div className={cx(styles.carImageBig, styles.moveInBig)} style={inStyle} />}
          {carOut && <div className={cx(styles.carImageBig, styles.moveOutBig)} style={outStyle} />}
        </Fragment>
      )}
    </div>
  );
};
